import { render, staticRenderFns } from "./last-winnings.vue?vue&type=template&id=29ff1ca5"
import script from "./last-winnings.vue?vue&type=script&lang=js"
export * from "./last-winnings.vue?vue&type=script&lang=js"
import style0 from "./last-winnings.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/last-winnings/last-winnings.vue
// module id = ZUiy
// module chunks = 0